import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderMathQuestion = _resolveComponent("RenderMathQuestion")!
  const _component_FormattedNumber = _resolveComponent("FormattedNumber")!

  return (_ctx.answerRenderKind && _ctx.answerRender)
    ? (_openBlock(), _createBlock(_component_RenderMathQuestion, {
        key: 0,
        "question-kind": _ctx.answerRenderKind,
        question: _ctx.answerRender
      }, null, 8, ["question-kind", "question"]))
    : (_ctx.question?.answerKind == 'buttons')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.answerOption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_RenderMathQuestion, {
                  "question-kind": _ctx.optionFormat,
                  question: _ctx.answerOptionLabel
                }, null, 8, ["question-kind", "question"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.question?.answerKind == 'singleop')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.answerOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_RenderMathQuestion, {
                    "question-kind": _ctx.optionFormat,
                    question: _ctx.answerOptionLabel
                  }, null, 8, ["question-kind", "question"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.jsonData !== null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.isPlain)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.answer), 1)
                  ], 64))
                : (_ctx.question?.answerKind == 'multiop')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.jsonData.join(", ")), 1))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.jsonData, (a, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(a.color ? 'g-color-' + a.color : '')
                        }, [
                          (a.label)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(a.label) + ": ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (!isNaN(Number(a.value)))
                            ? (_openBlock(), _createBlock(_component_FormattedNumber, {
                                key: 1,
                                value: Number(a.value),
                                format: a.fullFormat
                              }, null, 8, ["value", "format"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(a.value), 1)
                              ], 64))
                        ], 2)
                      ]))
                    }), 128))
            ], 64))
          : _createCommentVNode("", true)
}